import React from "react";

export default function Takashi() {
  return (
    <div className="takashi">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-5 col-lg-4">
            <div className="takashi-ln-bg">
              <h1>Takashinu Treasury</h1>
              <p>
                Our Treasury tax goes straight to the treasury wallet where
                funds are compounded into ask prices, for art objects and NFT’s
                that have already caught our eye long before this project
                stealth launched. The idea behind this is to generate as much
                income for the holders as possible.
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-6">
          <div className="col-md-7 col-lg-8"></div>
          <div className="col-md-5 col-lg-4 ">
            <div className="takashi-yellow-bg">
              <p>
                by both direct ( swing trading objects) and indirect (
                Gallery/metaverse showcases & Marketing). This will generate
                more holding and more importantly buying pressure than selling
                pressure. Using our future DAO based governce we make sure to
                keep adding the right great works to our arsenal.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
